import { DateTime } from "luxon";

const EDT_ZONE = "America/New_York";
const UNASSIGNED_TIME = "A time has not been assigned yet.";

const formatClock = (dateTime: DateTime) => dateTime.toFormat("h:mm a");
const formatDate = (dateTime: DateTime) =>
  dateTime.toFormat("cccc, LLLL d, yyyy");

const toEdt = (value?: string | null) => {
  if (!value) return null;
  const dateTime = DateTime.fromISO(value).setZone(EDT_ZONE);
  return dateTime.isValid ? dateTime : null;
};

export const formatCoffeeChatStartTime = (
  startValue?: string | null,
  endValue?: string | null
): string => {
  const start = toEdt(startValue);
  if (!start) return UNASSIGNED_TIME;

  const end = toEdt(endValue);
  if (!end) {
    return `${formatDate(start)} at ${formatClock(start)} EDT`;
  }

  if (start.hasSame(end, "day")) {
    return `${formatDate(start)} from ${formatClock(start)} – ${formatClock(
      end
    )} EDT`;
  }

  return `${formatDate(start)} at ${formatClock(start)} – ${formatDate(
    end
  )} at ${formatClock(end)} EDT`;
};
